import Vue from 'vue'
import Router from 'vue-router'
import Layout from "../layout";
import {getToken} from '../utils/auth';
import {getBtnAuth} from '../utils/btnAuth';
import {getTree} from '../utils/menuAuth';
import store from '../store';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            meta: {title: '登录', requiresAuth: false},
            component: (resolve) => require(['@/views/login'], resolve),
        }, {
            path: '/errorPage',
            meta: {title: '错误页面', requiresAuth: false},
            component: resolve => require(['@/views/errorPage'], resolve)
        },
        {
            path: '/order',
            component: Layout,
            hidden: true,
            name: '订单管理',
            meta: {title: '订单管理', enTitle: 'Order Management', requiresAuth: true},
            children: [
                {
                    component: resolve => require(['@/views/finance/rechargeOrder/index'], resolve),
                    name: '充值订单',
                    meta: {title: '充值订单', enTitle: 'Recharge Order', requiresAuth: true},
                    path: 'rechargeOrder',
                },
                {
                    component: resolve => require(['@/views/finance/rechargeLog/index'], resolve),
                    name: '充值日志',
                    meta: {title: '充值日志', enTitle: 'Recharge Log', requiresAuth: true},
                    path: 'rechargeLog',
                },
                {
                    component: resolve => require(['@/views/finance/rechargeThird/index'], resolve),
                    name: '第三方订单',
                    meta: {title: '第三方订单', enTitle: 'Third-party order', requiresAuth: true},
                    path: 'rechargeThird',
                },
                {
                    component: resolve => require(['@/views/finance/rechargeConfig/index'], resolve),
                    name: '充值配置',
                    meta: {title: '充值配置', enTitle: 'Recharge config', requiresAuth: true},
                    path: 'rechargeConfig',
                },
            ]
        }, {
            path: '/recharge',
            component: Layout,
            hidden: true,
            name: '充值',
            meta: {title: '充值', enTitle: 'Recharge', requiresAuth: true},
            children: [
                {
                    component: resolve => require(['@/views/finance/rechargeOverview/index'], resolve),
                    name: '充值概览',
                    meta: {title: '充值概览', enTitle: 'Recharge Overview', requiresAuth: true},
                    path: 'rechargeOverview',
                },
                {
                    component: resolve => require(['@/views/finance/rechargeRecord/index'], resolve),
                    name: '充值记录',
                    meta: {title: '充值记录', enTitle: 'Recharge record', requiresAuth: true},
                    path: 'rechargeRecord',
                },
            ]
        }, {
            name: '数据分析',
            component: Layout,
            hidden: true,
            path: '/analysis',
            meta: {title: '数据分析', enTitle: 'Data Analysis', requiresAuth: true},
            children: [{
                path: 'customerAnalysis',
                component: resolve => require(['@/views/analysis/customerAnalysis/index'], resolve),
                name: '客户数据',
                meta: {title: '客户数据', enTitle: 'Cusotmer Date', requiresAuth: true},
            },
            ]
        }, {
            name: '客户工作台',
            component: Layout,
            hidden: true,
            path: '/v2Workbench',
            meta: {title: '客户工作台', enTitle: 'New Customer workbench', requiresAuth: true},
            children: [
                {
                    path: 'analytics',
                    component: resolve => require(['@/views/v2Workbench/analytics/index'], resolve),
                    name: '数据看板',
                    meta: {title: '数据看板', enTitle: 'Data board', requiresAuth: true},
                },
                {
                    path: 'customer',
                    component: resolve => require(['@/views/v2Workbench/customer/index'], resolve),
                    name: '客户管理',
                    meta: {title: '客户管理', enTitle: 'Customer Management', requiresAuth: true},
                },
                {
                    path: 'link',
                    component: resolve => require(['@/views/v2Workbench/link/index'], resolve),
                    name: 'Link 管理',
                    meta: {title: 'Link 管理', enTitle: 'Link v2Workbench', requiresAuth: true},
                },
                {
                    path: 'details',
                    component: resolve => require(['@/views/v2Workbench/details/index'], resolve),
                    name: '账单明细',
                    meta: {title: '账单明细', enTitle: 'Bill Details', requiresAuth: true},
                },
            ]
        }, {
            path: '/newCustomer',
            component: Layout,
            hidden: true,
            name: 'AWS费用',
            meta: {title: 'AWS费用', enTitle: 'New AWS Fees', requiresAuth: true},
            children: [
                {
                    path: 'awsBill',
                    component: resolve => require(['@/views/newCustomer/awsBill/index'], resolve),
                    meta: {title: 'AWS账单', enTitle: 'AWS Bill', requiresAuth: true},
                    name: 'AWS账单',
                },
            ]

        }
    ]
})

// router.beforeEach(async (to, from, next) => {
//   if (to.meta.requiresAuth) {
//     if (!getToken()) {
//       // 未登录直接拦截
//       return next({ path: '/' })

//     }

//     try {
//       let btnAuth = null
//       const btnAllAuth = getBtnAuth() || {}
//       console.log('btnAllAuth', btnAllAuth);

//       if (btnAllAuth) {
//         const toPathBtnAuth = btnAllAuth[to.path] || {}
//         btnAuth = toPathBtnAuth[to.name] || null
//       }

//       // 缓存中没有权限时重新获取
//       if (!btnAuth) {
//         const menuList = getTree()
//         if (!menuList) {
//           throw new Error('菜单列表不存在')
//         }

//         const tree = JSON.parse(menuList)
//         console.log(tree);

//         // 使用递归查找所有层级的路由
//         const findUniqueCode = (items) => {
//           for (const item of items) {
//             if (item.url === to.path) {
//               return item.uniqueCode
//             }
//             if (item.childList && item.childList.length) {
//               const childCode = findUniqueCode(item.childList)
//               if (childCode) return childCode
//             }
//           }
//           return null
//         }

//         const uniqueCode = findUniqueCode(tree)
//         console.log('uniqueCode', uniqueCode);

//         if (!uniqueCode) {
//           throw new Error('未找到匹配的权限标识')
//         }

//         // 等待权限获取完成
//         btnAuth = await store.dispatch('updateBtnAuthAsync', uniqueCode)
//         console.log('btnAuth', btnAuth);

//         if (!btnAuth) {
//           throw new Error('未获取到按钮权限')
//         }
//       }

//       // 缓存权限
//       btnAllAuth[to.path] = btnAuth
//       // 设置权限并放行
//       store.commit('SET_BTN_AUTH', btnAuth)
//       store.commit('SET_ALL_BTN_AUTH', btnAllAuth)
//       next()
//     } catch (error) {
//       console.error('权限校验失败:', error)
//       next({ path: '/' })
//     }
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js